import Head from 'next/head';

import { useAppContext } from '~/utilities/context/static/AppContext';
import { useStaticContext } from '~/utilities/context/static/StaticContext';

export const AlgoliaPreconnect = () => {
  const { isProduction, algoliaCustomHost } = useAppContext();
  const { configuration: { algoliaAppId } = {} } = useStaticContext();

  if (isProduction) {
    return (
      <Head key="algolia-preconnect-custom-host">
        {algoliaCustomHost.map(host => (
          <link key={host} rel="preconnect" crossOrigin="anonymous" href={`https://${host}`} />
        ))}
      </Head>
    );
  }

  return (
    algoliaAppId && (
      <Head key="algolia-preconnect-direct-host">
        <link
          rel="preconnect"
          crossOrigin="anonymous"
          href={`https://${algoliaAppId.toLocaleLowerCase()}-dsn.algolia.net`}
        />
      </Head>
    )
  );
};
